






















































import Vue from 'vue';
import { MessageState, Message } from "@/common/types/Message";
import { mapGetters } from "vuex";

interface Data {
  dontClose: boolean;
  unseenMessages: number;
  messages: Array<Message>;
}

export default Vue.extend({
  name: 'OctMessageMenu',
  data: (): Data => ({
    dontClose: false,
    unseenMessages: 0,
    messages: [],
  }),
  computed: {
    MESSAGE(): Message {
      return this.$store.getters['MESSAGE'];
    }
  },
  methods: {
    resetCounter() {
      this.unseenMessages = 0;
    },
    mapMessageStateToIcon(messageState: MessageState): string | undefined {
      switch (messageState) {
      case 'error':
        return 'mdi-alert';
      case 'info':
        return 'mdi-information-outline';
      case 'warning':
        return 'mdi-alert-circle-outline';
      case 'success':
        return 'mdi-checkbox-marked-circle-outline';
      }
    }
  },
  watch: {
    MESSAGE() {
      this.messages.unshift(this.MESSAGE);
      this.unseenMessages++;
    }
  }
});
